import { SimpleClientLayer } from "./SimpleClientLayer";
export class MeasurementLayer extends SimpleClientLayer {
    constructor(opts) {
        super(opts);
        this.tooltips = [];
    }
    add_tooltip(t) {
        this.tooltips.push(t);
    }
    clear() {
        this.tooltips.filter(t => t.active).forEach(t => t.remove_from(this));
        this.tooltips = [];
    }
}
